import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../../../core/config/app-config.token';
import { BiddingEventDetailsDto, BiddingEventDto } from './bidding-events.dto';

export interface SubmitProposalProductRequest {
  volume: number;
  price: number;
}

export interface SubmitProposalRequest {
  butane: SubmitProposalProductRequest | null;
  propane: SubmitProposalProductRequest | null;
}

@Injectable({ providedIn: 'root' })
export class BiddingApiService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(APP_CONFIG);

  getBiddingEvents(): Observable<BiddingEventDto[]> {
    return this.http.get<BiddingEventDto[]>(`${this.config.apiUrl}/BiddingEvents`);
  }

  downloadGuide(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.config.apiUrl}/Guide`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  activateBiddingEvent(id: string): Observable<void> {
    return this.http.post<void>(
      `${this.config.apiUrl}/BiddingEvents/${encodeURIComponent(id)}/proposal/activate`,
      {},
    );
  }

  getBiddingEventDetails(id: string): Observable<BiddingEventDetailsDto> {
    return this.http.get<BiddingEventDetailsDto>(
      `${this.config.apiUrl}/BiddingEvents/${encodeURIComponent(id)}/proposal`,
    );
  }

  submitBiddingEventProposal(id: string, payload: SubmitProposalRequest): Observable<void> {
    return this.http.post<void>(
      `${this.config.apiUrl}/BiddingEvents/${encodeURIComponent(id)}/proposal/submit`,
      payload,
    );
  }

  withdrawBiddingEventProposal(id: string): Observable<void> {
    return this.http.post<void>(
      `${this.config.apiUrl}/BiddingEvents/${encodeURIComponent(id)}/proposal/withdraw`,
      {},
    );
  }
}
